import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    emoji: '📱',
    title: 'Social Media Content Calendar',
    desc: '30 days of done-for-you post ideas and captions.',
    value: '29'
  }, {
    emoji: '📝',
    title: 'Client Assessment Forms',
    desc: 'Professional PAR-Q and lifestyle questionnaires.',
    value: '19'
  }, {
    emoji: '💰',
    title: 'Pricing Calculator',
    desc: 'Excel tool to calculate exactly what you need to charge.',
    value: '25'
  }, {
    emoji: '📧',
    title: 'Email Templates',
    desc: 'Welcome emails, check-ins, and re-engagement scripts.',
    value: '29'
  }, {
    emoji: '🎯',
    title: 'Goal Setting Worksheets',
    desc: 'Help clients define and track their true motivations.',
    value: '15'
  }, {
    emoji: '⚖️',
    title: 'Cancellation Policy Template',
    desc: 'Stop losing money to no-shows with this legal framework.',
    value: '28'
  }];
  return <section className="bg-nero-card py-16 md:py-24 border-y border-nero-border/20" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-soft-gold text-2xl md:text-4xl font-bold font-playfair mb-2" data-id="element-4">
            🎁 6 STRATEGIC BONUSES
          </h2>
          <p className="text-white text-sm md:text-base tracking-widest uppercase" data-id="element-5">
            ALWAYS INCLUDED
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-6">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-nero-card border-l-4 border-soft-gold rounded-r-xl p-5 shadow-lg flex flex-col justify-between" data-id="element-7">
              <div data-id="element-8">
                <div className="text-soft-gold font-bold text-lg mb-2 flex items-center gap-2" data-id="element-9">
                  <span data-id="element-10">{bonus.emoji}</span> Bonus #{idx + 1}
                </div>
                <h3 className="text-white font-bold mb-2" data-id="element-11">{bonus.title}</h3>
                <p className="text-secondary-text text-sm mb-4" data-id="element-12">{bonus.desc}</p>
              </div>
              <div className="flex items-center gap-2 text-sm" data-id="element-13">
                <span className="text-gray-500 line-through" data-id="element-14">
                  Value NZD ${bonus.value}
                </span>
                <span className="text-soft-gold font-bold" data-id="element-15">→ FREE</span>
              </div>
            </div>)}
        </div>

        <div className="bg-nero-mid border border-soft-gold rounded-xl p-6 text-center max-w-2xl mx-auto" data-id="element-16">
          <p className="text-soft-gold text-xl md:text-2xl font-bold" data-id="element-17">
            Total bonus value NZD $145 → FREE with your MegaPack
          </p>
        </div>
      </div>
    </section>;
}